import {createContext} from 'react';

export const PostContext = createContext({}); // Hold core data of the post
